import {
  localDateEndToUtcIso,
  localDateStartToUtcIso,
} from '../../components/activity-log/call-activity-log.utils';
import { fetchWithCredentials } from './client';
import {
  AppendCallLogRequest,
  AppendCallLogResponse,
  CallTraceListParams,
  ListCallLogsResponse,
  ListCallTracesResponse,
} from './call-log.types';

function appendSearchParams(
  searchParams: URLSearchParams,
  params?: CallTraceListParams & { callTraceId?: string; cxoneContactId?: string }
): void {
  if (params?.callTraceId) searchParams.set('callTraceId', params.callTraceId);
  if (params?.cxoneContactId) searchParams.set('cxoneContactId', params.cxoneContactId);
  if (params?.fromDate) searchParams.set('fromDate', localDateStartToUtcIso(params.fromDate));
  if (params?.toDate) searchParams.set('toDate', localDateEndToUtcIso(params.toDate));
  if (params?.callerSearch) searchParams.set('callerSearch', params.callerSearch);
  if (params?.limit !== undefined) searchParams.set('limit', String(params.limit));
  if (params?.offset !== undefined) searchParams.set('offset', String(params.offset));
}

const listTracesInflight = new Map<string, Promise<ListCallTracesResponse>>();

function listTracesCacheKey(params?: CallTraceListParams): string {
  return JSON.stringify(params ?? {});
}

export const callLogApi = {
  async append(request: AppendCallLogRequest): Promise<AppendCallLogResponse> {
    return fetchWithCredentials<AppendCallLogResponse>('/api/v1/call-logs', {
      method: 'POST',
      body: JSON.stringify({ body: request }),
    });
  },

  async list(
    params?: CallTraceListParams & { callTraceId?: string; cxoneContactId?: string }
  ): Promise<ListCallLogsResponse> {
    const searchParams = new URLSearchParams();
    appendSearchParams(searchParams, params);

    const query = searchParams.toString();
    const endpoint = query ? `/api/v1/call-logs?${query}` : '/api/v1/call-logs';
    return fetchWithCredentials<ListCallLogsResponse>(endpoint);
  },

  async listTraces(params?: CallTraceListParams): Promise<ListCallTracesResponse> {
    const cacheKey = listTracesCacheKey(params);
    const inflight = listTracesInflight.get(cacheKey);
    if (inflight) {
      return inflight;
    }

    const searchParams = new URLSearchParams();
    appendSearchParams(searchParams, params);

    const query = searchParams.toString();
    const endpoint = query ? `/api/v1/call-logs/traces?${query}` : '/api/v1/call-logs/traces';

    const request = fetchWithCredentials<ListCallTracesResponse>(endpoint).finally(() => {
      listTracesInflight.delete(cacheKey);
    });

    listTracesInflight.set(cacheKey, request);
    return request;
  },
};
